<spot-nav [title]="'Email Preview'"
  [isMobile]="true"
(back)="goBack.emit(false)"></spot-nav>
<mat-toolbar class="mobile-preview__title-background">
  <span class="mobile-preview__reward-title">{{title}}</span>
</mat-toolbar>
@if (loading) {
  <div
    class="mobile-preview__loading-wheel"
    [cfaLoading]="true">
  </div>
}
@if (!loading) {
  <div>
    <template-preview [isMobile]="true"
      [type]="type"
      [rsvp]="rsvp"
      [rsvpHtml]="rsvpHtml"
      [noRsvpHtml]="noRsvpHtml"
      [appPreviewOverride]="appPreviewOverride"
      [templateHtml]="templateHtml"
      [rewardGiftMessage]="selectedEngagement.rewardDetails?.appMessage ?? selectedEngagement.automationCampaignDetails?.appMessage"
      [rewardProductImageUrl]="$safeNavigationMigration(selectedEngagement.customizations?.heroImage?.desktopURL)"
      [rewardProductName]="selectedEngagement.rewardDetails?.name ?? selectedEngagement.automationCampaignDetails?.title"
      [rewardExpiryDate]="($safeNavigationMigration(selectedEngagement.rewardDetails?.endDatetime) | date:'MM/dd/yyyy' ) ??  ''"
      [rewardLocationName]="$safeNavigationMigration((location$ | async)?.locationName)"
      [rewardOperatorImageUrl]="$safeNavigationMigration((location$ | async)?.operatorImageUrl)"
      [includeOperatorPhoto]="includeOperatorPhoto"
      [rewardOperatorName]="(location$ | async)?.operatorName ? ($safeNavigationMigration((location$ | async)?.operatorName) + ', Chick-fil-A Owner Operator') : null">
    </template-preview>
    <div class="mobile-preview__footer" fxLayout="row" fxLayoutAlign="space-around">
      <button mat-button (click)="goBack.emit(false)" class="mobile-preview__back-button">
        Back
      </button>
      @if (mode != 'review') {
        <button mat-button (click)="send()"
          class="mobile-preview__primary-button"
          [disabled]="readOnlyUser$ | async">
          {{mode === 'edit' ? 'Update' : 'Send'}}
        </button>
      }
    </div>
  </div>
}
